"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6809],{

/***/ 66809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WindowFetcher": function() { return /* binding */ WindowFetcher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39309);
/* harmony import */ var _BaseFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(862);




var WindowFetcher = /*#__PURE__*/ function(BaseFetcher) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WindowFetcher, BaseFetcher);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(WindowFetcher);
    function WindowFetcher() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, WindowFetcher);
        return _super.apply(this, arguments);
    }
    var _proto = WindowFetcher.prototype;
    _proto.fetch = function fetch() {
        return window.fetch;
    };
    WindowFetcher.create = function create(param) {
        var config = param.config, token = param.token;
        return new WindowFetcher(config, token);
    };
    return WindowFetcher;
}(_BaseFetcher__WEBPACK_IMPORTED_MODULE_0__/* .BaseFetcher */ .p);


/***/ })

}]);